<template>
  <div class="sidebar-expanded">
    <div class="sidebar-expanded__top__link">
      <router-link
         class="el-button el-button--text"
        :to="backTo.route">
        <i class="el-icon-arrow-left" aria-hidden="true"></i>{{ backTo.label }}
      </router-link>
    </div>
    <div class="sidebar-expanded__top">
      <div class="sidebar-expanded__top__product-information">
        <instance-section-profile-card
          :InstanceInfo="SysAdminInstanceDetails">
        </instance-section-profile-card>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__top -->
    <div class="sidebar-expanded__center">
      <div class="sidebar-expanded__menu">
        <el-menu
           class="el-menu--nuttrema-navigation-menu"
          :router="true"
          :default-active="$route.path"
          :unique-opened="true"
          @open="handleOpen"
          @close="handleClose">
          <template v-for="navigation in navigations">

            <el-submenu
               v-if="navigation.type === 'section'"
              :index="navigation.url">
              <template slot="title">
                <span>{{ $t(navigation.label) }}</span>
              </template>
              <el-menu-item
                 v-for="(page, childIndex) in navigation.pages"
                 v-if="checkGeneralPermition(_get(details, 'meta.permissions.general'), _get(page, 'requiredPermissionsGeneral'))"
                :class="page.class"
                :index="replaceID(page.url)"
                :route="{ name: page.name, params: { id }}"
                :key="replaceID(page.url)">
                <span>{{ $t(page.label) }}</span>
              </el-menu-item>
            </el-submenu>

            <template v-else>
              <el-menu-item
                 v-if="checkGeneralPermition(_get(details, 'meta.permissions.general'), _get(navigation, 'requiredPermissionsGeneral'))"
                :class="navigation.class"
                :route="{ name: navigation.name, params: { id }}"
                :index="replaceID(navigation.url)">
                <i v-if="navigation.navigationIcon" :class="navigation.navigationIcon"></i>
                <span class="is-title">{{ $t(navigation.label) }}</span>
              </el-menu-item>
            </template>

          </template>
        </el-menu>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__center -->
    <div class="sidebar-expanded__bottom" v-if="details.ready">
      <nuttrema-status-label
        :id="id"
        :fetching="details.fetching"
        :status="details.data.status">
      </nuttrema-status-label>
    </div>
    <!-- end ~ sidebar-expanded__bottom -->
</div>
</template>

<script>
import NuttremaStatusLabel from 'components/ui/label/nuttrema-status-label';

import InstanceSectionProfileCard from 'components/ui/card/instance-section-profile-card';

import SidebarMenu from 'components/ui/menu/sidebar-menu';
import ReturnQuery from 'components/mixins/return-query';

export default {
  name: 'sidebar-menu-sys-admin-instance-details-expanded',
  mixins: [
    ReturnQuery,
    SidebarMenu,
  ],
  components: {
    NuttremaStatusLabel,
    InstanceSectionProfileCard,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
    details: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      icon: null,
      theme: null,
      dividerTitle: 'label.instance_details',
      startingUrl: '/system-administration/instances/',
    };
  },
  computed: {
    SysAdminInstanceDetails() {
      return this.$store.getters.SysAdminInstanceDetails(this.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/system-administration/sidebar-menu-sys-admin-instance-details-expanded.vue